import { useTranslations } from 'next-intl';

interface IProps {
  text: string;
  textSize?: number;
}

// Puts a text over the center of the parent block.
export const OverlayMessage: React.FC<IProps> = ({ text, textSize = 40 }) => {
  const t = useTranslations();

  return (
    <div className="position-absolute top-50 start-50 translate-middle">
      <span className="text-black fw-bold" style={{ fontSize: textSize }}>
        {t(text)}
      </span>
    </div>
  );
};
